import Menu from '@assets/icons/menu.svg'
import { Icon } from './Icon'

export const MenuIcon = Icon(Menu)
